<template lang="pug">
  .ForbiddenForPublic Фукнционал недоступен для публичных рабочих пространств
</template>

<script>
  export default {
    name: "forbidden-for-public"
  }
</script>

<style scoped lang="scss">
  @import '~base';
  .ForbiddenForPublic {
    width: 300px;
    margin: 100px auto;
    font-size: 14px;
    line-height: 1.5;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/ForbiddenForPublic.vue